module.exports = __webpack_public_path__ + "media/images/yahoo-icon-fca430211c3eb9a7e4ef2543ebf6bcc1.svg";